import type { Network } from "../types";

export const threads: Network = {
  name: "Threads",
  shareUrl: "https://www.threads.net/intent/post?url=[u]",
  args: {
    title: "&text=[t]",
  },
  icon: "/media/images/social-share-threads.png",
  color: "#000000",
};
